export enum Role {
    broker = 'broker',
    employer = 'employer'
}
